export const DASHBOARD_EMAIL_CHART_ID_ALIASES: readonly [string, string][] = [
  ['incompliant_transactions_breakdown', 'fraudulent_transactions_breakdown'],
  ['incompliant_transaction_count_histogram', 'fraudulent_transaction_count_histogram'],
  ['incompliant_transactions', 'fraudulent_transactions'],
  ['false_positives_breakdown', 'false_positives'],
  ['false_declines_breakdown', 'false_declines'],
];

export function toCanonicalDashboardChartId(chartId: string): string {
  for (const [aliasSuffix, canonicalSuffix] of DASHBOARD_EMAIL_CHART_ID_ALIASES) {
    if (chartId.endsWith(aliasSuffix)) {
      return `${chartId.slice(0, chartId.length - aliasSuffix.length)}${canonicalSuffix}`;
    }
  }
  return chartId;
}

export function toDashboardChartLabel(chartId: string, dashboardKey: string | undefined): string {
  const prefix = dashboardKey ? `${dashboardKey}_` : '';
  if (prefix !== '' && chartId.startsWith(prefix)) {
    return chartId
      .substring(prefix.length)
      .split('_')
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  }
  return chartId;
}
